import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadGTM, removeGTM } from "../utils/loadGTM";

const GTM_ID = "GTM-5SJXBWNV"; // your GTM ID

const GTMManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Load GTM ONLY on these routes:
    if (path === "/enquiry" || path === "/thank-you" || path === "/home" || path === "/join-us" || path === "/customer/services" || path === "/customer/about-us" || path === "/customer/contact-us") {
      loadGTM(GTM_ID);
    } else {
      removeGTM(); // remove on all other routes
    }

  }, [location.pathname]);

  return null;
};

export default GTMManager;